import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import webLogin from '@utils/weblogin';
import videoService from '@services/videoService';
import LazyImage from '../../../../../basic/lazy-image';
export default {
  name: 'Profile',
  props: {
    authentication: Object,
    channelID: String,
    anchorID: String,
    heatCount: Number
  },
  data: function data() {
    return {
      VideoAPIService: null,
      // / 用户信息。
      portrait: '',
      name: '',
      isFollowed: false,
      praiseCount: 0,
      diamondCount: 0
    };
  },
  components: {
    'lazy-image': LazyImage
  },
  filters: {
    format: function format(value) {
      return util.nFormatter(value, 1);
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.VideoAPIService = videoService.createApi();
    this.updateAnchorInfo();
    this.updateCurrencyInfo();
  },
  computed: {
    anchorInfoDependencies: function anchorInfoDependencies() {
      return {
        anchorID: this.anchorID,
        authentication: this.authentication
      };
    },
    currencyInfoDependencies: function currencyInfoDependencies() {
      return {
        channelID: this.channelID,
        anchorID: this.anchorID
      };
    }
  },
  methods: {
    updateAnchorInfo: function updateAnchorInfo() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var userinfo, _userinfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.anchorID) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!webLogin.checkLogin()) {
                _context.next = 13;
                break;
              }
              _context.next = 5;
              return _this.VideoAPIService.getUserInfo(_this.anchorID);
            case 5:
              userinfo = _context.sent.user.user_info;
              _this.portrait = userinfo.face || util.defaultUserPortrait(userinfo);
              _this.name = userinfo.uname;
              _this.isFollowed = userinfo.is_relation === '50001' /* < 已关注 > */ || userinfo.is_relation === '50008';
              _this.praiseCount = +userinfo.praise;
              _this.VideoAPIService.getProfile(_this.anchorID, _this.authentication).then(function (data) {
                _this.portrait = data.user_info.face;
                _this.name = data.user_info.nickname;
                _this.isFollowed = data.user_info.is_relation === '50001' || data.user_info.is_relation === '50008';
                _this.diamondCount = +data.user_info.diamond;
                _this.praiseCount = +userinfo.praise;
              }).catch(function (e) {
                if (e.status === 200 && e.data && e.data.status === '402') {
                  // 重置Authentication
                  _this.$lmBus && _this.$lmBus.$emit('Header-Login-Out-Handle');
                  webLogin.reset();
                }
              });
              _context.next = 20;
              break;
            case 13:
              _context.next = 15;
              return _this.VideoAPIService.getUserInfo(_this.anchorID);
            case 15:
              _userinfo = _context.sent.user.user_info;
              _this.portrait = _userinfo.face || util.defaultUserPortrait(_userinfo);
              _this.name = _userinfo.uname;
              _this.isFollowed = _userinfo.is_relation === '50001' /* < 已关注 > */ || _userinfo.is_relation === '50008';
              _this.praiseCount = +_userinfo.praise;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateCurrencyInfo: function updateCurrencyInfo() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var currency;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!_this2.channelID || !_this2.anchorID)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return _this2.VideoAPIService.getHostCurrency(_this2.channelID, _this2.anchorID);
            case 4:
              currency = _context2.sent;
              _this2.diamondCount = +currency.hostcurrencynum;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    subscribeHandler: function subscribeHandler() {
      if (!this.anchorID) {
        return;
      }
      this.$emit('subscribe', this.anchorID, this.isFollowed, 3);
    },
    openCardHandler: function openCardHandler() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var local, json, otherWindow;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // pcv2 需要 不跳转到 主播个人页 && this.anchorID
              local = util.getI18nLocale();
              json = {
                pathname: "/".concat(local, "/u/").concat(_this3.anchorID, "/index.html"),
                search: {}
              };
              otherWindow = window.open(util.directToPath(json));
              if (otherWindow) {
                otherWindow.opener = null;
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  },
  watch: {
    anchorInfoDependencies: function anchorInfoDependencies() {
      this.updateAnchorInfo();
    },
    currencyInfoDependencies: function currencyInfoDependencies() {
      this.updateCurrencyInfo();
    }
  }
};